import { Component } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe'
// services imports
import { ServerMapping } from './../service/serverMapping.service';
import { Locale } from './../service/locale.service';
import { AccountService } from './../service/accountService.service';
import { Status } from './../service/status.service';
import { CustomizingService } from './../service/customizingService.service';
import { LabelFormatService } from './../service/labelFormatService.service';
import { InternalFunctionsRedirectService } from './../service/internalFunctionsRedirectService.service';
// manager imports
import { ModelsManager } from './../manager/models.manager';
import { DateTimeManager } from './../manager/datetime.manager';
import { GrowlManager } from './../manager/growl.manager';
import { DownloadManager } from './../manager/download.manager';
import { ValidatorManager } from './../manager/validator.manager';

// class exportation
@Component({
    providers: [Locale,
                Status,
                AccountService,
                CustomizingService,
                LabelFormatService,
                InternalFunctionsRedirectService]
})
export class Exposer {

	private orderingPipe: OrderPipe;

    constructor(private locale: 				Locale,
                private serverMapping:          ServerMapping,
                private accountService: 		AccountService,
                private customizingService:     CustomizingService,
                private IFRS:                   InternalFunctionsRedirectService,
                private status: 				Status,
                private labelFormatService:     LabelFormatService,
                private modelsManager:          ModelsManager,
                private dateTimeManager:        DateTimeManager,
                private downloadManager:        DownloadManager,
                private validatorManager:       ValidatorManager,
                private growlManager:           GrowlManager) {
		this.orderingPipe = new OrderPipe();
        this.status.setExposer(this);
    }

    // exposes the locale service
    public getLocale() { return this.locale; }

    // exposes the server mapping
    public getServerMapping() { return this.accountService; }

    // exportes the account service
    public getAccountService() { return this.accountService; }

    // exposes the param service
    public getCustomizingService() { return this.customizingService; }

    // exposes the IFRS service
    public getIFRS() { return this.IFRS; }

    // exposes the status service
    public getStatus() { return this.status; }

    // exposes the models manager
    public getModelsManager() { return this.modelsManager; }

    // exposes the label format service
    public getLabelFormatService() { return this.labelFormatService; }

    // exposes the date time manager
    public getDateTimeManager() { return this.dateTimeManager; }

    // exposes the validator manager
    public getValidatorManager() { return this.validatorManager; }

    // exposes the growl manager
    public getGrowlManager() { return this.growlManager; }

    // exposes the download manager
    public getDownloadManager() { return this.downloadManager; }
	
	// exposes the sorting object
	public getSorter() { return this.orderingPipe }
}



// WEBPACK FOOTER //
// ./src/app/components/exposer.component.ts